export const WIZARD_TRACK_CLICK_TYPE = {
    CLICKED_WIZARD_SPLASH: 2,
    CLICKED_WIZARD_TIPPING_SCREEN: 5,
    CLICKED_WIZARD_SINGLE_QR: 6,
    CLICKED_WIZARD_MULTIPLE_QR: 7,
    CLICKED_WIZARD_TEST_QR: 8,
    CLICK_WIZARD_PRINT_SIGN: 9,
    CLICK_WIZARD_DOWNLOAD_SIGN: 10,
    CLICK_WIZARD_FINISH: 11,
} as const;

export type WizardTrackClickType =
    (typeof WIZARD_TRACK_CLICK_TYPE)[keyof typeof WIZARD_TRACK_CLICK_TYPE];
